import React, { useImperativeHandle, useState, useCallback, forwardRef, useRef } from 'react';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';

//* Components
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';

//* Style
import FormContainerStyle from './style';

const FormContainer = forwardRef(({ layout, className, ...props }, ref) => {
	//! Form
	const [form] = useForm();

	//! Send Form as Ref
	useImperativeHandle(ref, () => {
		return form;
	});

	//! States
	const [error, setError] = useState();

	//! On Value Change
	const onValuesChange = (newVal, vals) => {
		props.onChange && props.onChange(newVal, vals, form);
	};

	//! On Finish
	const onFinish = useCallback(
		(values) => {
			form.setFields([]);
			setError('');

			props
				.onFinish(values)
				.then((res) => {
					form.resetFields();
					Promise.resolve(res);
				})
				.catch((err) => {
					console.error(err, 'Error in form');
					if (err?.data) {
						const formVals = [];

						if (typeof err.data.message === 'string') {
							setError(err.data.message);
						}

						for (let key in values) {
							formVals.push({
								name: key,
								value: values[key],
								errors: [err.data.errors?.[key]]?.[0],
							});
						}
						form.setFields(formVals);
					} else if (err.message) {
						if (typeof err.message === 'string') {
							setError(err.message);
						}
					}

					Promise.reject(err?.data);
				});
		},
		[props, form]
	);

	const formRef = useRef();

	return (
		<FormContainerStyle>
			<div ref={formRef}>
				{error && (
					<div className='global-error'>
						<div className='error-panel'>
							<Icon
								name={'close'}
								className={'global-error-close-icon'}
							/>
						</div>

						<div className='error-panel-text'>
							<Text
								className={'p error-message font-ping-medium'}
								text={error}
							/>

							<Text
								className={'p pXS font-ping-medium'}
								text={'globalErrorText'}
							/>
						</div>
					</div>
				)}
				<Form
					form={form}
					onFinish={onFinish}
					layout={layout || ''}
					className={className || ''}
					onValuesChange={onValuesChange}
					initialValues={props.initialValues}>
					{props.children}
				</Form>
			</div>
		</FormContainerStyle>
	);
});

FormContainer.displayName = 'FormContainer';

export default FormContainer;
